export default "__VITE_ASSET__BitTFJg4__"